import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function GuaranteeBox() {
  return <section className="max-w-lg mx-auto px-4 pb-8" data-id="element-25">
      <div className="bg-soft-beige rounded-xl p-5 border-2 border-rose-gold/30" data-id="element-26">
        <div className="flex items-center gap-2 mb-3" data-id="element-27">
          <CheckCircle2Icon className="w-5 h-5 text-rose-gold" data-id="element-28" />
          <h3 className="text-base font-semibold text-deep-cocoa" data-id="element-29">
            Garantía sin estrés
          </h3>
        </div>

        <p className="text-sm text-deep-cocoa/80 leading-relaxed" data-id="element-30">
          Si en los próximos <span className="font-semibold" data-id="element-31">30 días</span>{' '}
          sientes que la guía no es para ti, te devolvemos tu dinero sin
          preguntas. Queremos que estés 100% tranquila con tu decisión.
        </p>
      </div>
    </section>;
}